import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import { Box } from '@mui/material';
import { numberFormat, maskAmount } from '../helpers/helperFunctions';

/* eslint-disable react/prop-types */
export default function AreaApexChart({ name, target, actual, maskAmountValue = false }) {
  const [idname] = useState(name);
  const [renderChart, setRenderChart] = useState(false);

  const options = {
    series: [
      {
        name: 'Target',
        data: target,
      },
      {
        name: 'Actual',
        data: actual,
      },
    ],
    chart: {
      height: 350,
      type: 'area',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return maskAmountValue ? maskAmount(numberFormat(value)) : numberFormat(value);
        },
      },
    },
    xaxis: {
      type: 'date',
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
  };

  useEffect(() => {
    if (renderChart) {
      const chart = new ApexCharts(document.querySelector(`#${idname}`), options);
      chart.render();
    }
    setRenderChart(true);
  }, [renderChart]);

  return (
    <Box sx={{ width: '100%', overflowY: 'scroll', overflowX: 'scroll' }}>
      <div id={idname} />
    </Box>
  );
}
